import Link from 'next/link';
import styled from 'styled-components';

import { ChevronRightIcon } from '@components/icons';
import { Caption2 } from '@components/styles/Typography';
import { capitalizeSentences } from '@utils';

const Breadcrumb = ({
    parentName,
    parentSlug,
    productName,
    subCategoryName,
    subCategorySlug,
}) => (
    <BreadcrumbWrapper data-testid="breadcrumb">
        <BreadcrumbItem to="/" href="/" passHref>
            <Caption2 color="bgGray25">Fervente</Caption2>
            <ChevronRightIcon />
        </BreadcrumbItem>
        {parentSlug && (
            <BreadcrumbItem
                to={`/${parentSlug}`}
                href={`/${parentSlug}`}
                passHref
            >
                <Caption2 color="bgGray25">
                    {capitalizeSentences(parentName)}
                </Caption2>
                <ChevronRightIcon />
            </BreadcrumbItem>
        )}
        {subCategorySlug && (
            <BreadcrumbItem
                to={`/${subCategorySlug}`}
                href={`/${subCategorySlug}`}
                passHref
            >
                <Caption2 color="bgGray25">
                    {capitalizeSentences(subCategoryName)}
                </Caption2>
                <ChevronRightIcon />
            </BreadcrumbItem>
        )}
        <BreadcrumbItem href="#" passHref>
            <Caption2 color="bgGray25">
                {capitalizeSentences(productName)}
            </Caption2>
            <ChevronRightIcon />
        </BreadcrumbItem>
    </BreadcrumbWrapper>
);
const BreadcrumbWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    position: relative;
    width: 100%;
    margin-top: 20px;
    @media (max-width: 1024px) {
        margin-top: 10px;
    }
`;
export const BreadcrumbItem = styled(Link)`
    cursor: pointer;
    display: flex;
    align-items: center;
    text-transform: capitalize;
    white-space: nowrap;

    svg {
        margin: 0 5px;
        height: 8px;
    }

    :last-child {
        span {
            color: ${({ theme }) => theme.colors.primary};
        }

        svg {
            display: none;
        }

        @media (max-width: 1024px) {
            max-width: 60vw;
            overflow: scroll;
            white-space: nowrap;

            ::-webkit-scrollbar {
                display: none;
            }
        }
    }

    :hover {
        span {
            text-decoration: underline;
            color: ${({ theme }) => theme.colors.primary};
        }
    }
`;

export default Breadcrumb;
